import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "forward" }, [
  /*#__PURE__*/_createElementVNode("g", { id: "Group 546" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector",
      d: "M15 16.5L20 11.5L15 6.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector_2",
      d: "M4 17.5V15.5C4 14.4391 4.42143 13.4217 5.17157 12.6716C5.92172 11.9214 6.93913 11.5 8 11.5H20",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }